var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['switch-tab__panel', {'is-expanded': _vm.isActive}],attrs:{"role":"panel","id":("switch-tab-" + _vm.id + "-panel"),"aria-labelledby":("switch-tab-" + _vm.id + "-btn"),"aria-expanded":("" + _vm.isActive),"aria-hidden":(_vm.isActive + " === false")}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d63c892c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/switch-tab/switch-tab-panel.vue
// module id = null
// module chunks = 